import React from 'react';
import { Form, Select } from "antd";
import Icons from "components/icons";
import { Localize } from "components/service";


const UserGenderSelect = ({
    disabled = false,
    rules = true,
    initialValue,
    mode = '',
    name = 'gender',
    label = Localize({ children: "FORMS.Input_Label_Gender" }).props.children
}) => {


    return (
        <Form.Item
            name={ name }
            label={ label }
            initialValue={ initialValue }
            rules={ rules && [ { required: true, message: `${ Localize({ children: "FORM_RULES.Required_Choose" }).props.children } ${ label }` } ] }
        >
            <Select
                showSearch
                suffixIcon={ <Icons.Arrow /> }
                mode={ mode }
                className="select-serch-input"
                disabled={ disabled }
                placeholder={ `${ Localize({ children: "FORMS.Input_Placeholder_Choose" }).props.children } ${ label }` }
                popupClassName="select-serch-dropdown"
                optionFilterProp="value"
            >

                <Select.Option key="male" value="male"><Localize>FORMS.Select_OptionLabel_Male</Localize> </Select.Option>
                <Select.Option key="female" value="female"><Localize>FORMS.Select_OptionLabel_Female</Localize> </Select.Option>

            </Select>
        </Form.Item>
    );

}

export default UserGenderSelect;


